import { render, staticRenderFns } from "./ListPlantingSchool.vue?vue&type=template&id=34711e59"
import script from "./ListPlantingSchool.vue?vue&type=script&lang=js"
export * from "./ListPlantingSchool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports